import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import { Link } from 'react-router-dom';
import CardSimple from 'screens/components/basic/CardSimple';
import SelectInput from 'screens/components/basic/SelectInput';
import TimePickerInput from 'screens/components/basic/TimePickerInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import { getAllEmployees, saveShift } from 'actions/EntityActions';
import { formInput, formError, clearFormErrors } from 'actions/FormActions';
import { selectShiftModel } from 'selectors/entitySelector';
import { showSnackbar, showError } from 'actions/CommonActions';
import util from 'library/util';
import Grid from 'screens/components/basic/Grid';
import { shiftAddCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';

const componentName = 'ShiftAdd';

class ShiftAdd extends Component {
    constructor(props) {
        super(props);

    }

    componentWillMount() {
        this.props.getEmployees();
        this.props.formInput(null, `${componentName}ClockIn`);
        this.props.formInput(null, `${componentName}ClockOut`);
        this.props.formInput(``, `${componentName}EmployeeId`);
        this.props.formInput(null, `${componentName}Date`);

        this.props.clearFormErrors();
    }

    componentWillReceiveProps = (newProps) => {
        if (this.props.saveTimestamp !== newProps.saveTimestamp) {
            if (newProps.saveSuccess === true) {
                this.redirectToList();
                this.props.showSnackbar(LOOKUP.shiftEdit.savedMessage);
            }
            else {
                this.props.showError(newProps.saveError);
            }
        }
    }

    redirectToList = () => {
        this.props.navigate(`/admin/shift/list`);
    }

    save = () => {
        const model = this.props.model;

        const validators = [
            [`${componentName}EmployeeId`, model => (model.EmployeeId !== null && model.EmployeeId !== 0), 'Employee'],
            [`${componentName}Date`, model => (model.Date !== null && model.Date !== ""), 'Date'],
            [`${componentName}ClockIn`, model => (model.PunchInDate !== null && model.PunchInDate !== ""), 'Clock In Time']
        ];

        if (util.validate(validators, model, this.props.formError)) {
            this.props.save(model);
        }
    }

    render() {
        const p = this.props;

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.admin.items.shiftList.link}>{LOOKUP.menu.admin.items.shiftList.text}</Link></li>
                    <li className="active">{LOOKUP.menu.admin.items.shiftAdd.text}</li>
                </ol>
                <h2>{LOOKUP.menu.admin.items.shiftAdd.text} <Button type="HeaderBackPage" onTouchTap={() => this.redirectToList()} /></h2>
            </div>
        );

        const employeeOptions = p.employees.map(item => {
            return {
                text: `${item.firstName} ${item.lastName}`,
                value: item.id.toString()
            };
        });

        return (
            <Grid headerContent={shiftAddCrumb}>
                <PageHeader title={LOOKUP.menu.admin.items.shiftAdd.text} />
                <CardSimple>
                    <div className="row m-0">
                        <div className="col-lg-6">
                            <SelectInput
                                name={`${componentName}EmployeeId`}
                                label={LOOKUP.shiftList.filters.employee.label}
                                floatingLabelText={LOOKUP.shiftList.filters.employee.label}
                                hintText={LOOKUP.shiftList.filters.employee.label}
                                options={employeeOptions}
                                required
                            />
                        </div>
                        <div className="col-lg-6">
                            <DatePickerInput
                                name={`${componentName}Date`}
                                id="inputDateIn"
                                floatingLabelText={LOOKUP.shiftEdit.dateIn.label}
                                hintText={LOOKUP.shiftEdit.dateIn.hintText}
                                required
                             />
                        </div>
                    </div>
                    <div className="row m-0">
                        <div className="col-lg-6">
                            <TimePickerInput
                                name={`${componentName}ClockIn`}
                                id="inputClockInTime"
                                floatingLabelText="Clock In Time"
                                label="Clock In Time"
                                hintText="Clock In Time"
                                required
                            />
                        </div>
                        <div className="col-lg-6">
                            <TimePickerInput
                                name={`${componentName}ClockOut`}
                                id="inputClockOutTime"
                                floatingLabelText="Clock Out Time"
                                label="Clock Out Time"
                                hintText="Clock Out Time"
                                fullWidth={true}
                            />
                        </div>
                    </div>
                </CardSimple>
                <PageBottomWithButtons>
                    <Button
                        name="saveButton"
                        className="pull-right"
                        label="Save"
                        onTouchTap={() => this.save()}
                        primary={true} />
                    <Button
                        type="CancelButton"
                        name="buttonCancel"
                        className="pull-right btn-space btnCancelOperation"
                        onTouchTap={() => this.redirectToList()}
                        label="Cancel" />
                </PageBottomWithButtons>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        model: selectShiftModel(state, componentName),
        saveTimestamp: state.form[`${componentName}SaveTimestamp`],
        saveSuccess: state.form[`${componentName}SaveSuccess`],
        saveError: state.form[`${componentName}SaveError`],
        employees: state.entity.employeeList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        getEmployees: () => dispatch(getAllEmployees()),
        save: (model) => dispatch(saveShift(model, componentName)),
        formError: (name, error) => dispatch(formError(name, error)),
        clearFormErrors: () => dispatch(clearFormErrors())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ShiftAdd));